import { descending } from 'd3'

export function makeRows (syncsResponse) {
  if (!syncsResponse) return []
  if (!Array.isArray(syncsResponse)) return []
  if (syncsResponse.length === 0) return []

  syncsResponse.sort(function (a, b) {
    return descending(a.started_at, b.started_at) ||
      descending(a.scheduled_time, b.scheduled_time) ||
      descending(a.created_at, b.created_at)
  })

  return syncsResponse
}
